import { sanitizeHTML } from 'utils/SecurityHelper';
import { HelpArticleListProps } from './config';
import React, { useEffect, useRef } from 'react';
import { HelpArticleProps } from '../HelpArticle/config';
import './styles.scss';

function a11yProps(index: number) {
  return {
    id: `help-article-tab-button-${index}`,
    'aria-controls': `faq-ec-group-${index}`,
  };
}

const HelpArticleList = ({
  faqTitle,
  faqArticles,
  linkText,
  linkURL,
  readFullArticle,
  displaySummary,
}: HelpArticleListProps) => {
  const [activeIndex, setActiveIndex] = React.useState(0);
  let helpArticleListElementRef = useRef<HTMLDivElement>(null!);
  const handleClick = (event: any, newIndex: any) => {
    event.preventDefault();
    setActiveIndex(newIndex);
    setTimeout(() => {
      isReadMoreHidden(`faq-ec-group-${newIndex}`);
    });
  };

  const isReadMoreHidden = (id: string) => {
    if (
      document.getElementById(id) &&
      document.getElementById(id)!.scrollHeight >
        document.getElementById(id)!.offsetHeight
    ) {
      helpArticleListElementRef.current
        .querySelectorAll(`#${id} .fn_faq-read-more`)[0]
        .classList.remove('js-hidden');
      helpArticleListElementRef.current
        .querySelectorAll(`#${id}`)[0]
        .classList.add('is-overflown');
    }
  };

  useEffect(() => {
    if (window.grunticon) {
      window.grunticon.embedIcons(
        window.grunticon.getIcons(window.grunticon.getCSS(window.grunticon.href))
      );
    }

    if (window.faqInitAnalytics) {
      window.faqInitAnalytics();
    }
  }, []);

  return (
    <div className="tu-help-article-list" ref={helpArticleListElementRef}>
      <div className="module module--faq module--grey module--padded">
        <div className="module__content l-padding">
          <h3>{faqTitle}</h3>

          {/* START faq module content */}
          <div className="faq fn_faq">
            <ul>
              {faqArticles?.map((article: HelpArticleProps, index: number) => {
                return (
                  <li key={`faq-ec-group-${index}`}>
                    {/* This href must match the id on the following div */}
                    <a
                      href={`#faq-ec-group-${index}`}
                      {...a11yProps(index)}
                      className={`fn_js-ec-link js-ec-link expandcollapse ${
                        index === activeIndex ? 'is-expanded' : ''
                      }`}
                      onClick={(e) =>
                        index === activeIndex
                          ? handleClick(e, null)
                          : handleClick(e, index)
                      }
                    >
                      {article.faqArticleTitle}
                      <div className="ec"></div>
                    </a>
                    {/* Add the class is-expanded to have the item be expanded initially. Make sure data-ec-group is set on each of the divs and they have the same unique value */}
                    <div
                      id={`faq-ec-group-${index}`}
                      className={`js-ec expandcollapse-content${
                        index === activeIndex ? ' is-expanded' : ''
                      }`}
                      data-ec-group="faq-ec-group"
                    >
                      <div className="faq__title">
                        <h4>{article.faqArticleTitle}</h4>
                      </div>
                      {displaySummary && article.summaryField ? (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHTML(article.summaryField),
                          }}
                        ></div>
                      ) : (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: sanitizeHTML(article.answerField),
                          }}
                        ></div>
                      )}
                      {readFullArticle && (
                        <div className="faq__read-more fn_faq-read-more js-hidden">
                          <a href={`${article.articleLink}`}>{readFullArticle}</a>
                        </div>
                      )}
                      {/* optional view all link, do not render if not specified--> */}
                      {article.summaryText && (
                        <a href={`${article.summaryLink}`} className="faq__view-all">
                          {article.summaryText}
                        </a>
                      )}
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
          {linkText && linkURL && (
            <a href={`${linkURL}`} className="btn btn--link">
              {linkText}
              <span className="icon icon--arrow-right" data-grunticon-embed="true"></span>
            </a>
          )}
          {/* END faq module content */}
        </div>
      </div>
    </div>
  );
};

export default HelpArticleList;
